import { Link } from 'react-router-dom';
import { APP_NAME } from '@/lib/brand.constants';
import {
  LANDING_CONTACT_ADDRESS,
  LANDING_CONTACT_EMAIL,
} from '@/constants/landing.constants';
import { BrandMark } from '@/components/common/BrandMark';

export function LandingFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-neutral-200 bg-white">
      <div
        data-testid="landing-footer-content"
        className="mx-auto flex max-w-6xl flex-col items-center gap-6 px-4 py-10 text-center sm:px-6 lg:px-8"
      >
        <div className="flex max-w-sm flex-col items-center">
          <BrandMark size="sm" imageClassName="h-10 w-auto max-h-10" />
          <p className="mt-4 text-sm font-medium leading-6 text-neutral-700">
            <a
              href={`mailto:${LANDING_CONTACT_EMAIL}`}
              className="inline-flex min-h-10 items-center rounded-md text-teal-700 transition-colors hover:text-teal-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-teal-600 focus-visible:ring-offset-2"
            >
              {LANDING_CONTACT_EMAIL}
            </a>
          </p>
          <p className="text-sm leading-6 text-neutral-600">{LANDING_CONTACT_ADDRESS}</p>
        </div>

        <div className="flex flex-col items-center gap-3 border-t border-neutral-200 pt-6 text-sm text-neutral-500">
          <p className="leading-6">
            © {year} {APP_NAME}.
          </p>
          <nav aria-label="Links legais" className="flex flex-wrap justify-center gap-2">
            <Link
              to="/privacy"
              className="inline-flex min-h-10 items-center rounded-md px-1 font-medium text-teal-700 transition-colors hover:text-teal-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-teal-600 focus-visible:ring-offset-2"
            >
              Privacidade
            </Link>
            <span className="flex min-h-10 items-center text-neutral-300" aria-hidden>
              ·
            </span>
            <Link
              to="/terms"
              className="inline-flex min-h-10 items-center rounded-md px-1 font-medium text-teal-700 transition-colors hover:text-teal-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-teal-600 focus-visible:ring-offset-2"
            >
              Termos
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}
